import Vue from 'vue'
import { AxiosError, AxiosResponse } from 'axios'

const serviceRelations = [
  'sale_category', 'vat_rate', 'unit', 'technicians', 'products', 'default_picture', 'custom_quantity_prices', 
  'custom_type_prices', 'custom_fields'
]

const needFetchService = (service: KwixeoCatalog.Service|KwixeoCatalog.FormService): boolean => {
  return !serviceRelations.every(relation => relation in service)
}

const fetchService = async (id: number|string): Promise<KwixeoCatalog.Service> => {
  return await Vue.prototype.$kwCatalog.axios.get('/catalog/service/' + id, {
      params: {
        include: serviceRelations.join(',')
      }
    })
    .then((response: AxiosResponse) => {
      return response.data
    })
    .catch((error: AxiosError) => {
      throw new Error((error.response as AxiosResponse)?.data)
    })
}

export {
  serviceRelations, needFetchService, fetchService
}
